var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-fill flex-column no-scroll dashboard py-4 px-6"},[_c('landing-page',{attrs:{"items":_vm.items,"urlParams":_vm.urlParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }